import * as React from "react"

function ArrowButtonSvg(props) {
  return (
    <svg
      data-name="Capa 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 66.73 66.73"
      {...props}
    >
      <g data-name="Capa 1">
        <circle cx={33.37} cy={33.37} r={33.37} fill={props.circleColor || "#fff"} />
        <path
          fill="#003f88"
          d="M22.96 56.8L20.16 53.39 44.59 33.37 20.16 13.35 22.96 9.93 51.56 33.37 22.96 56.8z"
        />
      </g>
    </svg>
  )
}

export default ArrowButtonSvg